export const NO_UPPER_LIMIT_OPTION = -1;
